import { createAsyncThunk } from "@reduxjs/toolkit";
import apiBilling from "@/lib/api/billing";
import { IUserSlice, TPaymentOption } from "@/redux/slices/user/types";

export const getPaymentOptions = createAsyncThunk(
  "user/getPaymentOptions",
  apiBilling.getPaymentOptions
);

const pending = (state: IUserSlice) => {
  state.user.payment_options.loading = true;
};

const fulfilled = (
  state: IUserSlice,
  { payload }: { payload: TPaymentOption[] }
) => {
  state.user.payment_options.loading = false;
  state.user.payment_options.options = payload;
};

const rejected = (state: IUserSlice) => {
  state.user.payment_options.loading = false;
  state.user.payment_options.options = [];
};

export default {
  action: getPaymentOptions,
  pending,
  fulfilled,
  rejected,
};
